import React, { Component } from "react";
import RestServiceStatic from "../services/rest.service"
import Form from 'react-bootstrap/Form';

import Container from "react-bootstrap/Container";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";

export default class LoginFediverse extends Component {

  constructor(props) {

    super(props);

    this.state = {
      isLoading: false,
      message: "",
    };

    this.loginWithFediverse = this.loginWithFediverse.bind(this);
  }

  loginWithFediverse() {

    this.setState({isLoading : true});

    // JUST FOR TESTING PURPOSES. REMOVE IT!!!
    // if (this.props.type === "Mastodon") {
    //   localStorage.setItem('MastodonInstance', "mas.to");
    // } else {
    //   localStorage.setItem('PixelfedInstance', "pixelfed.social");
    // }

    let instance = localStorage.getItem(this.props.type + 'Instance');

    RestServiceStatic.fediverseRegisterApp(instance, this.props.type).then(response => {

        if (!response.data) {
          window.location.href = "/error"
        } else {

            if (response.data.clientId && response.data.sanitizedInstance) {

              localStorage.setItem(this.props.type + 'Instance', response.data.sanitizedInstance);

              window.location.href = "https://" + response.data.sanitizedInstance + "/oauth/authorize?client_id=" + response.data.clientId + "&scope=" + this.props.permision + "&redirect_uri=" + this.props.url + "&response_type=code&force_login=true";
              return;
            }

            this.setState({
                isLoading: false,
                message: response.data.message,
            });
            
        }

    }).catch(e => {

        console.log("CATCH:" + e);
        window.location.href = "/error"

    });
  }

  handleChange = (event) => {
    localStorage.setItem(this.props.type + 'Instance', event.target.value);
  }
  

  render() {

    const onFormSubmit = e => {
      e.preventDefault();
      this.loginWithFediverse();
    }

    return (
        <Container className="loginContainer">
          <Form onSubmit={onFormSubmit}>
            <Form.Group className="mb-3" controlId="formBasicFediverseInstance">
              <Form.Label>Enter the name of your {this.props.type} Instance</Form.Label>
              <Form.Control placeholder={this.props.placeholder} onChange={this.handleChange} disabled={this.state.isLoading ? true : false}/>
              {this.state.message ? 
                <Form.Text className="text-danger">
                  {this.state.message}
                </Form.Text>
              :
                ""
              }
            </Form.Group>
            {this.props.disclaimer ? 
              <Form.Check type="checkbox" required={true}
              label="I accept that using this service to find my Mastodon followings in Pixelfed I am also allowing my Mastodon followers to find me in Pixelfed." />
              : ""
            }
            <div className="col text-center mt-4">
              <Button variant="primary" type="submmit" disabled={this.state.isLoading ? true : false}>
                {this.state.isLoading  
                  ?   <Spinner as="span" animation="grow" role="status" aria-hidden="true" size="sm"/>  
                  :   this.props.icon} Sign in with {this.props.type}
              </Button>
            </div>
          </Form>
        </Container>
    );
  }


}
